import { useEffect, useRef, useState } from "react";
import logger from "../../console";

const useIntersectionObserver = (threshold = 0.5) => {
  const [isIntersecting, setIsIntersecting] = useState(false);
  const [hasRendered, setHasRendered] = useState(false);
  const [count, setCount] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        logger.log({ entry });
        setIsIntersecting(entry.isIntersecting);
        if (entry.isIntersecting && !hasRendered) {
          if (count > 1) setHasRendered(true);
          else setCount((prevCount) => ++prevCount);
        }
      },
      { threshold },
    );

    const element = ref.current;
    if (element) {
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [threshold, hasRendered, count]);

  logger.log({ isIntersecting, hasRendered });

  return [isIntersecting || hasRendered, ref];
};

export default useIntersectionObserver;
